import { wrapMethodsWithLogging } from "../../components/helpers/ErrorHandlingHelpers";
import BaseApiRepository from "./BaseApiRepository";

const AuthApiRepository = {
    
    async getLoginUrlAsync(returnUrl) {
        return await BaseApiRepository.getAsync(`auth/login-url?returnUrl=${returnUrl}`);
    },

    async getLogoutUrlAsync() {
        return await BaseApiRepository.getAsync('auth/logout-url');
    },

    async getApplicationRightsAsync() {
        return await BaseApiRepository.getAsync('auth/application-rights');
    }

};
wrapMethodsWithLogging(AuthApiRepository);

export default AuthApiRepository;
